import { api } from '@/apis';
import { isEmpty, log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useTelematicsBoxResets({ boundary, query: filter }) {
  const queryKey = ['telematicsBoxResets', boundary, filter];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const featurePipeline = [
        {
          $match: {
            ...filter,
            ...(boundary
              ? { point: { $geoWithin: { $geometry: boundary } } }
              : {}),
          },
        },
        {
          $project: {
            _id: false,
            id: '$identifier',
            type: 'Feature',
            geometry: '$point',
            properties: {
              imei: '$vehicle.telematicsBoxImei',
              time: '$time',
              speedKilometresPerHour: '$speedKilometresPerHour',
              vehicle: {
                registrationNumber: '$vehicle.registrationNumber',
                fleetNumber: '$vehicle.fleetNumber',
                role: '$vehicle.role',
                type: '$vehicle.type',
                homeStation: '$vehicle.homeStation',
              },
              speedMilesPerHour: {
                $round: [
                  { $multiply: ['$speedKilometresPerHour', 0.62137119] },
                  2,
                ],
              },
            },
          },
        },
        {
          $setWindowFields: {
            sortBy: { 'properties.time': 1 },
            output: {
              id: {
                $count: {},
                window: { documents: ['unbounded', 'current'] },
              },
            },
          },
        },
      ].filter(Boolean);

      log('Read', 'Telematics Box Resets', { query: filter });

      return api
        .post('pipeline/telematicsBoxResets', {
          json: featurePipeline,
          signal,
        })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60 * 8,
    enabled: !isEmpty(filter),
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
